// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b81d45a5","513":"2bc43997","703":"4ad9c93e","787":"36ff37cd"}[chunkId] + ".chunk.js";
};